module.exports = __webpack_public_path__ + "img/cabin-side.40371a04.webp";